(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["j-carousel-controls"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('j-carousel'))customElements.define('j-carousel',class extends HTMLElement{
connectedCallback(){
 if(this._events)return;this.track=this.querySelector('[data-carousel-track]');if(!this.track)return;
 this._events=new AbortController();const signal=this._events.signal;
 this.page=this.querySelector('[data-carousel-page]');this.previous=this.querySelector('[data-carousel-step="-1"]');this.next=this.querySelector('[data-carousel-step="1"]');this.control=this.querySelector('.j-carousel-controls');
 this.querySelectorAll('[data-carousel-step]').forEach(button=>button.addEventListener('click',()=>this.track.scrollBy({left:this.width*Number(button.dataset.carouselStep),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'}),{signal}));
 this.track.addEventListener('scroll',()=>{if(!this._frame)this._frame=requestAnimationFrame(()=>{this._frame=0;this.update()})},{signal,passive:true});
 this._resize=new ResizeObserver(()=>this.measure());this._resize.observe(this.track);this.measure();
}
disconnectedCallback(){this._events?.abort();this._events=null;this._resize?.disconnect();cancelAnimationFrame(this._frame);this._frame=0}
measure(){this.width=this.track.clientWidth;this.totalWidth=this.track.scrollWidth;this.total=Math.max(1,Math.ceil(this.totalWidth/(this.width||1)));this.control.hidden=this.totalWidth<=this.width+2;this.update()}
update(){if(!this.width)return;const left=this.track.scrollLeft,index=Math.min(this.total,Math.round(left/this.width)+1),label=index+' / '+this.total;if(this.page.textContent!==label)this.page.textContent=label;this.previous.disabled=left<2;this.next.disabled=left+this.width>=this.totalWidth-2}
});
  } catch(e) { console.error(e); }
})();

})();
